let activeNotes = 0;

const note = (message = '') => {
    let notes = document.querySelector('.loschlegal-notes');

    if (!notes) {
        notes = document.createElement('div');
        notes.classList.add('loschlegal-notes');
    }

    if( '' === message ) {
        return;
    }

    const note = document.createElement('div');
    const inner = document.createElement('div');
    const text = document.createElement('p');
    note.classList.add('loschlegal-note');
    inner.classList.add('loschlegal-note__inner', 'info');
    text.classList.add('loschlegal-note__text');
    text.innerHTML = message;
    inner.appendChild(text);
    note.appendChild(inner);
    notes.appendChild(note);

    const wpwrap = document.getElementById('wpwrap');
    if (wpwrap && !document.querySelector('.loschlegal-notes')) {
        wpwrap.appendChild(notes);
    }

    const siteMain = document.querySelector('.outer-wrap');
    if (siteMain && !document.querySelector('.loschlegal-notes')) {
        siteMain.appendChild(notes);
    }

    activeNotes++;

    setTimeout(() => {
        note.remove();
        activeNotes--;

        if (activeNotes === 0) {
            notes.remove();
        }
    }, 3000);
}

export default note;